import React, { useEffect, useState, Fragment, useRef } from "react";
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardContent from '@material-ui/core/CardContent';
import Grid from '@material-ui/core/Grid';
import '../../../../../assets/css/print.css'
var QRCode = require("qrcode.react");


export default class ComponentToPrint extends React.Component {

  renderqr(data) {
    let qrdata = (data == undefined || data == null || data.length === 0) ? null : (
      data.map((d) => {
        return (
          <div className="table-responsive row-top-gap">
            <br></br><br></br><br></br>
            <table>
              <thead>
                <tr>
                  <th style={{ fontWeight: "bold", textAlign: "left", fontSize: "20px" }} colSpan="5" width="50%" height="70">Name : {d.name}</th>
                  <th style={{ fontWeight: "bold", textAlign: "left", fontSize: "20px" }} colSpan="3" width="25%">Gender : {d.gender}</th>
                  <th colSpan="4" rowSpan="5" width="30%"><QRCode id={d.registrationNumber} value={d.cardNumber} size={250} bgColor="#FFFFFF" fgColor="#000000" /></th>
                </tr>
                <tr>
                  <th style={{ fontWeight: "bold", textAlign: "left", fontSize: "20px" }} colSpan="4" height="70">Date Of Birth : {d.dateOfBirth}</th>
                  <th style={{ fontWeight: "bold", textAlign: "left", fontSize: "20px" }} colSpan="4" width="40%">NIC : {d.nic}</th>
                </tr>
                <tr>
                  <th style={{ fontWeight: "bold", textAlign: "left", fontSize: "20px" }} colSpan="4" height="70">EPF NO : {d.epfNo}</th>
                  <th style={{ fontWeight: "bold", textAlign: "left", fontSize: "20px" }} colSpan="4" width="40%">EMP NO : {d.registrationNumber}</th>
                </tr>
                <tr>
                  <th style={{ fontWeight: "bold", textAlign: "left", fontSize: "20px" }} colSpan="8" height="70">Card NO : {d.cardNumber}</th>
                </tr>
                <tr>
                  <th style={{ fontWeight: "bold", textAlign: "left", fontSize: "20px" }} colSpan="4" height="70">Estate : {d.estateName}</th>
                  <th style={{ fontWeight: "bold", textAlign: "left", fontSize: "20px" }} colSpan="4" width="40%">Division : {d.divisionName}</th>
                </tr>
              </thead>
            </table>
            <br></br><br></br><br></br>
            <br></br><br></br><br></br>
          </div>
        )
      })
    );
    return (
      <div>
        {qrdata}
      </div>
    )
  }

  render() {
    const renderqr = this.renderqr(this.props.data);
    return (
      <table>
        <tbody>
          {renderqr}
        </tbody>
      </table>
    );
  };
}


















